<template>
  <div
    class="commission-wrapper"
    v-if="
      inLocalKidsMiniprogram &&
      isPartner &&
      (directCommission || teamCommission)
    "
  >
    <div class="title">分销佣金 <span>仅合伙人可见</span></div>
    <div class="detail">
      <p v-if="directCommission" class="direct">
        直推佣金 <span>{{ directCommission }}</span>
      </p>
      <p v-if="teamCommission" class="team">
        团队佣金 <span>{{ teamCommission }}</span>
      </p>
      <p v-else class="team"></p>
      <img
        src="https://hzwimspic-1251601690.image.myqcloud.com/10001/b465a750-ee3d-11ed-934b-9f50bbafbc89_size_268x104"
        @click="goMiniMaterial"
      />
    </div>
  </div>
</template>

<script>
import utils from '@/plugins/utils'
import { miniProgram } from 'kwsdk'
export default {
  props: {
    commissionData: {
      type: Object,
      default: () => null
    },
    spuId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inLocalKidsMiniprogram: false
    }
  },
  methods: {
    goMiniMaterial() {
      miniProgram.navigateTo({
        url: `/pages/material/index?spuId=${this.spuId}`
      })
    }
  },
  computed: {
    directCommission() {
      const directCommission = this.commissionData
      const min =
        (directCommission?.partnerLevel === 1
          ? directCommission?.commonMinCommission
          : directCommission?.superMinCommission) ?? 0
      const max =
        (directCommission?.partnerLevel === 1
          ? directCommission?.commonMaxCommission
          : directCommission?.superMaxCommission) ?? 0
      if (max === 0) return ''
      if (min === max) {
        return `¥${parseFloat((min / 100).toFixed(2))}`
      }
      return `¥${parseFloat((min / 100).toFixed(2))}-${parseFloat(
        (max / 100).toFixed(2)
      )}`
    },
    teamCommission() {
      const directCommission = this.commissionData
      const min = directCommission?.teamMinCommission ?? 0
      const max = directCommission?.teamMaxCommission ?? 0
      if (max === 0) return ''
      if (min === max) {
        return `¥${parseFloat((min / 100).toFixed(2))}`
      }
      return `¥${parseFloat((min / 100).toFixed(2))}-${parseFloat(
        (max / 100).toFixed(2)
      )}`
    },
    isPartner() {
      const directCommission = this.commissionData
      return (
        directCommission?.partnerLevel === 1 ||
        directCommission?.partnerLevel === 2
      )
    }
  },
  async mounted() {
    this.inLocalKidsMiniprogram = await utils.isInLocalKidsMiniprogram()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.commission-wrapper {
  background: #ffffff;
  padding: rem(30px) rem(28px);
  margin: rem(20px) 0 0;
  background: #ffffff;
  .title {
    color: #000000;
    font-weight: 500;
    font-size: rem(30px);
    span {
      color: #999999;
      font-size: rem(24px);
      margin-left: rem(12px);
    }
  }
  .detail {
    margin-top: rem(24px);
    width: 100%;
    height: rem(88px);
    box-sizing: border-box;
    align-items: center;
    padding-left: rem(22px);
    padding-right: rem(18px);
    display: flex;
    background: url('https://hzwimspic-1251601690.image.myqcloud.com/10001/9a268410-ee3b-11ed-934b-9f50bbafbc89_size_1388x176')
      no-repeat;
    background-size: 100% 100%;

    .direct {
      margin-right: rem(16px);
    }
    .team {
      flex: 1;
    }
    p {
      color: #300000;
      font-size: rem(26px);
    }

    span {
      color: #ff2b2f;
    }

    img {
      width: rem(134px);
      height: rem(52px);
    }
  }
}
</style>
